import React from 'react';
import { MediaImagesItemRenderer } from './../menus/MediaImagesItemRenderer';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import properties from '../../constants/Properties';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import configuration from '../../constants/Configuration';

export const MediaImagesList = React.createClass({
    getInitialState() {
        return {
            currentPage: 0,
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.dataProvider && nextProps.dataProvider.length == 1)
            this.recreateElements();
        else
        if (nextProps.dataProvider && nextProps.dataProvider.length > 1 && nextProps.dataProvider[1] != undefined && this.shouldRefreshDataProvider(this.props.dataProvider, nextProps.dataProvider))
            this.recreateElements();
    },
    shouldRefreshDataProvider(oldData, newData) {
        if (!oldData || !newData)
            return false;

        if (oldData.length != newData.length)
            return true;
        else {
            var length = newData.length;

            if (length > 15)
                length = 15;

            for (var i=0; i<length; i++) {
                if (oldData[i] && newData[i] && oldData[i].status != newData[i].status)
                    return true;
            }

            return false;
        }
    },
    recreateElements() {
        setTimeout(this.refreshNewContent, 50);
    },
    refreshNewContent() {
        this.initElements();
    },
    initElements() {
        let elements = [];
        let items = this.props.dataProvider == undefined ? [] : this.props.dataProvider;
        let i;

        if (configuration.LOAD_LOCAL) {
            if (this.props.isVideo)
                items = populateMediaFilesUtils.getVideosDataProviderForTest();
            else
                items = populateMediaFilesUtils.getImagesDataProviderForTest();
        }

        var dif = '_images_';

        if (this.props.isVideo == true)
            dif = '_videos_';

        for (i=0; i<items.length; i++) {
            const item = items[i];
            elements.push(<MediaImagesItemRenderer length={items.length} isVideo={this.props.isVideo} index={i} usePagination={true} parentWidth={this.props.accordionWidth} item={item} key={'mediaImages' + dif + (i+1) + Math.random()}/>);
        }

        masterUniverseUtils.scrollPosition = 0;

        this.setState({
            currentPage: 0,
            allElements: elements,
            elements: this.getCurrentElements(elements, 0)
        });
    },
    getCurrentElements(allElements, page) {
        var hitsPerPage = 50;
        var maxIndex = hitsPerPage * (page + 1);
        var items = [];

        for (var i=0; i<allElements.length; i++) {
            if (i < maxIndex)
                items.push(allElements[i]);
            else
                break;
        }

        return items;
    },
    uploadNewPage(scrollTop) {
        if (Math.abs(scrollTop - masterUniverseUtils.scrollPosition) < 40)
            return;

        masterUniverseUtils.scrollPosition = scrollTop;

        var allElements = this.state.allElements ? this.state.allElements : [];

        this.setState({
            elements: this.getCurrentElements(allElements, this.state.currentPage + 1),
            currentPage: this.state.currentPage + 1
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if ((this.state && this.state.elements != nextState.elements) || this.props.accordionWidth != newProps.accordionWidth || this.props.isVideo != newProps.isVideo || this.shouldRefreshDataProvider(this.props.dataProvider, newProps.dataProvider) || this.props.height != newProps.height)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        let displayState = 'none';

        if (this.props.dataProvider && this.props.dataProvider.length > 0)
            displayState = 'inline-block';

        var topPosition = properties.BROWSER_BUTTON_HEIGHT + this.props.gap;

        topPosition = topPosition + properties.TOGGLE_TRACK_HEIGHT + this.props.gap + 2;

        var componentProperties = {};
        componentProperties.paddingTop = 5;
        componentProperties.paddingLeft = 3;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.height - topPosition;
        componentProperties.top = topPosition;
        componentProperties.displayState = displayState;
        componentProperties.elements = this.state.elements;

        componentProperties.usePagination = true;
        componentProperties.uploadNewPage = this.uploadNewPage;

        return (
            <ScrollableComponent componentProperties={componentProperties}/>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/MediaImagesList.js
 **/